// extracted by mini-css-extract-plugin
export var attachment = "_pb-a";
export var emailContainer = "_pb-4";
export var emailContentPaddedContainer = "_pb-b";
export var emailHeader = "_pb-6";
export var emailIframe = "_pb-3";
export var emailInfoIcon = "_pb-9";
export var emailShortenedSummary = "_pb-e";
export var infoDropdown = "_pb-0";
export var infoRowBoundedContent = "_pb-d";
export var internal = "_pb-5";
export var merchant = "_pb-8";
export var messageInputContainer = "_pb-h";
export var normal = "_pb-7";
export var replyCard = "_pb-f";
export var subtleButton = "_pb-1";
export var subtleButtonIconContainer = "_pb-2";
export var toggleViewRepliesButton = "_pb-c";
export var wrappingText = "_pb-g";